// Índice de documentos de la categoría: General
import solicitudes_externas_conceptos from './solicitudes-externas-conceptos.js';
import solicitudes_externas_practico from './solicitudes-externas-practico.js';
import campos_usuario_personalizados from './campos-usuario-personalizados.js';
import etiquetas_segmentacion from './etiquetas-segmentacion.js';
import asignar_conversacion_humano from './asignar-conversacion-humano.js';
import como_funciona_bandeja_entrada from './como-funciona-bandeja-entrada.js';
import contenido_dinamico from './contenido-dinamico.js';

const generalDocs = [
  solicitudes_externas_conceptos,
  solicitudes_externas_practico,
  campos_usuario_personalizados,
  etiquetas_segmentacion,
  asignar_conversacion_humano,
  como_funciona_bandeja_entrada,
  contenido_dinamico,
];

export default generalDocs;
